import FavoriteIcon from '@app/FavoriteIcon/FavoriteIcon.vue';

export default function install(Vue) {
  Vue.component(FavoriteIcon.name, FavoriteIcon)
}
